import { createRegExpFromString } from "@jti/fe-common";
export const getPostCodeValidationRules = (config, translate) => {
    const fieldRegex = createRegExpFromString(config.postcode_validate_regex);
    if (!config.postcode_validation_enabled) {
        return {
            required: {
                value: true,
                message: translate("form_validation.field_required"),
            },
        };
    }
    return {
        ...(config.postcode_min_length && {
            minLength: {
                value: config.postcode_min_length,
                message: translate("form_validation.min_length", [config.postcode_min_length]),
            },
        }),
        ...(config.postcode_max_length && {
            maxLength: {
                value: config.postcode_max_length,
                message: translate("form_validation.max_length", [config.postcode_max_length]),
            },
        }),
        ...(fieldRegex && {
            pattern: {
                value: fieldRegex,
                message: translate("form_validation.postcode_validate_regex"),
            },
        }),
        ...(config.postcode_is_required && {
            required: {
                value: config.postcode_is_required,
                message: translate("form_validation.field_required"),
            },
        }),
    };
};
//# sourceMappingURL=getPostCodeValidationRules.js.map